
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../MedicationForm"; // Import FormValues type from MedicationForm

interface MedicationFormFieldsProps {
  form: UseFormReturn<FormValues>;
}

export const MedicationFormFields = ({ form }: MedicationFormFieldsProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom du médicament</FormLabel>
            <FormControl>
              <Input required placeholder="Ex: Doliprane" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="dosage"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Dosage</FormLabel>
            <FormControl>
              <Input required placeholder="Ex: 1000mg" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="frequency"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Fréquence de prise</FormLabel>
            <FormControl>
              <Input required placeholder="Ex: 3 fois par jour" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="start_date"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date de début</FormLabel>
            <FormControl>
              <Input required type="date" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="end_date"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date de fin (optionnel)</FormLabel>
            <FormControl>
              <Input type="date" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="expiry_date"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date d'expiration</FormLabel>
            <FormControl>
              <Input type="date" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="reminder_time"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Heures de rappel (séparées par des virgules)</FormLabel>
            <FormControl>
              <Input 
                placeholder="Ex: 08:00, 12:00, 20:00" 
                {...field}
                onChange={(e) => {
                  const times = e.target.value.split(',').map(t => t.trim());
                  field.onChange(times);
                }}
                value={field.value?.join(', ') || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes additionnelles</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Ex: Prendre avec de l'eau, après les repas..."
                className="min-h-[100px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
